import { ReplenishmentTemplateCategoryCreatePage } from '@/features/replenishment-template-category/pages/ReplenishmentTemplateCategoryCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/replenishment-template-category/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["replenishment_template_category.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ReplenishmentTemplateCategoryCreatePage,
});
